// @flow

import React, { Component } from 'react';

/**
 * The type of the React {@code Component} props of {@link LargeVideoElement}.
 */
type Props = {

    /**
     * Used to determine the value of the autoplay attribute.
     */
    autoPlay: boolean,

    /**
     * The ID attribute of the video element.
     */
    id: string,

    /**
     * Used to determine the value of the muted attribute.
     */
    muted: boolean,

    /**
     * Used to determine the value of the playsinline attribute.
     */
    playsInline: boolean,

    /**
     * The React ref object to assign to the video element.
     */
    videoRef: Object,

    /**
     * The CSS styles to apply to the video element.
     */
    style: Object
};

/**
 * Component that renders the video element for the large video.
 * It is isolated in a separate component to blackbox it from React updates
 * and prevent Safari from reloading the video track on every state update.
 *
 * @augments Component
 */
class LargeVideoElement extends Component<Props> {
    /**
     * Implements shouldComponentUpdate to blackbox video element updates from React.
     *
     * @inheritdoc
     */
    shouldComponentUpdate(nextProps: Props) {
        return nextProps.style?.objectFit !== this.props.style?.objectFit
            || nextProps.style?.transform !== this.props.style?.transform
            || nextProps.autoPlay !== this.props.autoPlay;
    }

    /**
     * Renders the video element.
     *
     * @inheritdoc
     */
    render() {
        return (
            <video
                autoPlay = { this.props.autoPlay }
                id = { this.props.id }
                muted = { this.props.muted }
                playsInline = { this.props.playsInline }
                ref = { this.props.videoRef }
                style = { this.props.style } />
        );
    }
}

export default LargeVideoElement;
